module.exports = __webpack_public_path__ + "static/media/liked.29136b81.svg";